function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_10643_146835)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L0.25 0.6875L0 1.40625V2.125L1 3.8125L0 5.5V6.5L1 8L0 9.5V10.5L1 12.1875L0 13.875V16L0.6875 15.75L1.40625 16H2.125L3.8125 15L5.5 16H6.5L8 15L9.5 16H10.5L12.1875 15L13.875 16H16L15.75 15.3125L16 14.5938V13.875L15 12.1875L16 10.5V9.5L15 8L16 6.5V5.5L15 3.8125L16 2.125V0L15.3125 0.25L14.5938 0H13.875L12.1875 1L10.5 0H9.5L8 1L6.5 0H5.5L3.8125 1L2.125 0H0Z",
  fill: "#EEEEEE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 0V3.375L13.875 0H10.5ZM16 2.125L12.625 5.5H16V2.125ZM0 5.5H3.375L0 2.125V5.5ZM2.125 0L5.5 3.375V0H2.125ZM5.5 16V12.625L2.125 16H5.5ZM0 13.875L3.375 10.5H0V13.875ZM16 10.5H12.625L16 13.875V10.5ZM13.875 16L10.5 12.625V16H13.875Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0V1.40625L4.09375 5.5H5.5L0 0ZM6.5 0V6.5H0V9.5H6.5V16H9.5V9.5H16V6.5H9.5V0H6.5ZM14.5938 0L10.5 4.09375V5.5L16 0H14.5938ZM5.5 10.5L0 16H1.40625L5.5 11.9062V10.5ZM10.5 10.5L16 16V14.5938L11.9062 10.5H10.5Z",
  fill: "#D80027"
}));

function SvgEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10643_146835",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.b180892b.svg";
export { ForwardRef as ReactComponent };